const NoDataNotice = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-900">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md mx-auto">
        <h1 className="text-2xl font-bold mb-4 text-black">Notice</h1>
        <p className="text-lg text-gray-700 mb-6">
          No login data available. You are either trying to bypass Telegram and reach our app directly, or our server is down.
        </p>
        <p className="text-sm text-gray-500">
          In latter case we are already aware of the problem and trying to solve is asap!
        </p>
      </div>
    </div>
  );
};

export default NoDataNotice;